module.exports = __webpack_public_path__ + "static/media/church-detail.dfb5f41b.jpg";